(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-block"] && !Shopify.designMode) return;
  try {
    (function () {
  function initRoot(root) {
    if (root.dataset.bbReady === '1') return;
    root.dataset.bbReady = '1';

    var TOTAL = parseInt(root.dataset.totalSlots, 10) || 4;
    var PAID = parseInt(root.dataset.paidSlots, 10) || 2;
    var KEY = 'bb-picked-' + root.dataset.blockId;

    var modal = root.querySelector('.bb-modal');
    var stepPick = root.querySelector('.bb-step-pick');
    var stepReview = root.querySelector('.bb-step-review');
    var miniSlots = root.querySelector('.bb-mini-slots');
    var grid = root.querySelector('.bb-picker-grid');
    var tilesWrap = root.querySelector('.bb-review-tiles');
    var checkoutBtn = root.querySelector('.bb-checkout');
    var pickBtn = root.querySelector('.pick-button');
    var mainSlots = Array.prototype.slice.call(root.querySelectorAll('.bb-slot'));

    /* ---- product catalogue from hidden Liquid data ---- */
    var products = Array.prototype.map.call(root.querySelectorAll('.bb-product-data'), function (el) {
      return {
        id: el.dataset.variantId,
        title: el.dataset.title,
        price: parseInt(el.dataset.price, 10) || 0,
        priceFormatted: el.dataset.priceFormatted,
        image: el.dataset.image,
        images: (el.dataset.images || '').split('||').filter(Boolean),
        lowStock: el.dataset.lowStock === 'true'
      };
    });
    var byId = {};
    products.forEach(function (p) { byId[p.id] = p; });

    /* ---- state ---- */
    function load() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return null;
        var arr = JSON.parse(raw);
        if (!Array.isArray(arr) || arr.length !== TOTAL) return null;
        return arr.map(function (id) { return (id && byId[id]) ? id : null; });
      } catch (e) { return null; }
    }
    var picked = load() || new Array(TOTAL).fill(null);
    function save() { try { localStorage.setItem(KEY, JSON.stringify(picked)); } catch (e) {} }
    function clearSaved() { try { localStorage.removeItem(KEY); } catch (e) {} }

    function firstEmpty() { for (var i = 0; i < TOTAL; i++) if (!picked[i]) return i; return -1; }
    function count() { return picked.filter(Boolean).length; }
    function complete() { return count() === TOTAL; }
    function countFor(id) { return picked.filter(function (p) { return p === id; }).length; }
    function lastIndexOf(id) { for (var i = TOTAL - 1; i >= 0; i--) if (picked[i] === id) return i; return -1; }

    /* ---- money ---- */
    function symbol() {
      var m = (products[0] && products[0].priceFormatted || '').match(/^[^\d\s.,]+/);
      return m ? m[0] : '$';
    }
    function fmt(cents) { return symbol() + (cents / 100).toFixed(2); }

    /* charge the PAID most-expensive picks; the rest ride free */
    function totals() {
      var prices = picked.filter(Boolean).map(function (id) { return byId[id].price; }).sort(function (a, b) { return b - a; });
      var full = prices.reduce(function (s, p) { return s + p; }, 0);
      var charged = prices.slice(0, PAID).reduce(function (s, p) { return s + p; }, 0);
      console.log("prices: "  + prices + "--full: " + full + "--charged: " + charged );
      return { full: full, charged: charged, saving: full - charged };
      
    }

    /* ---- renderers ---- */
    function renderMainSlots() {
      mainSlots.forEach(function (slot, i) {
        var img = slot.querySelector('.bb-slot-img');
        var plus = slot.querySelector('.bb-slot-plus');
        var rem = slot.querySelector('.bb-slot-remove');
        var label = slot.querySelector('.bb-slot-label');
        var p = picked[i] ? byId[picked[i]] : null;
        if (p) {
          img.src = p.image; img.hidden = false;
          plus.style.display = 'none';
          rem.hidden = false;
          if (label) label.textContent = p.title;
        } else {
          img.removeAttribute('src'); img.hidden = true;
          plus.style.display = '';
          rem.hidden = true;
          if (label) label.textContent = label.dataset.orig || label.textContent;
        }
        if (label && !label.dataset.orig) label.dataset.orig = label.textContent;
      });
    }

    function renderMini() {
      var next = firstEmpty();
      var html = '';
      for (var i = 0; i < TOTAL; i++) {
        var p = picked[i] ? byId[picked[i]] : null;
        var cls = p ? 'filled' : (i === next ? 'next-empty' : '');
        html += '<div class="bb-mini-slot ' + cls + '">';
        html += p ? '<img src="' + p.image + '" alt="">' :
          '<span class="bb-mini-plus"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></span>';
        html += '</div>';
      }
      miniSlots.innerHTML = html;
    }

    function renderGrid() {
      if (products.length === 0) {
        grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;padding:24px;color:rgba(33,25,18,.55);font-size:13px;">No products found. Pick a collection in the block settings.</p>';
        return;
      }
      var html = '';
      products.forEach(function (p) {
        var c = countFor(p.id);
        html += '<div class="bb-card' + (c > 0 ? ' selected has-count' : '') + '" data-id="' + p.id + '">'
          + '<div class="bb-card-image">'
          + (p.lowStock ? '<span class="bb-card-low"><span class="bb-card-low-dot"></span>LOW STOCK</span>' : '')
          + '<button type="button" class="bb-card-zoom" aria-label="Zoom"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#211912" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35M11 8v6M8 11h6"/></svg></button>'
          + '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
          + '<button type="button" class="bb-card-add">Voeg toe</button>'
          + '<div class="bb-card-stepper">'
          +   '<button type="button" class="bb-step-minus" aria-label="Remove one">−</button>'
          +   '<span class="bb-step-count">' + c + '</span>'
          +   '<button type="button" class="bb-step-plus" aria-label="Add one">+</button>'
          + '</div>'
          + '</div>'
          + '<p class="bb-card-title">' + p.title + '</p>'
          + '<p class="bb-card-price">' + p.priceFormatted + '</p>'
          + '</div>';
      });
      grid.innerHTML = html;
    }

    function renderReview() {
      var html = '';
      for (var i = 0; i < TOTAL; i++) {
        var p = picked[i] ? byId[picked[i]] : null;
        if (!p) continue;
        html += '<div class="bb-tile" data-index="' + i + '">'
          + '<img src="' + p.image + '" alt="">'
          + '<button type="button" class="bb-tile-swap">SWAP <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#211912" stroke-width="2"><path d="M21 2v6h-6M3 22v-6h6M21 8a9 9 0 0 0-15-5.7L3 5M3 16a9 9 0 0 0 15 5.7L21 19"/></svg></button>'
          + '</div>';
      }
      tilesWrap.innerHTML = html;

      var t = totals();
      var amt = root.querySelector('.bb-savings-amount');
      if (amt) amt.textContent = t.saving > 0 ? fmt(t.saving) : '';
      var priceEl = root.querySelector('.bb-checkout-price');
      if (priceEl) priceEl.textContent = fmt(t.charged);
    }

    function renderAll() { renderMainSlots(); renderMini(); renderGrid(); }

    /* ---- modal open/close + steps ---- */
    function openModal(step) {
      showStep(step || 'pick');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bb-lock');
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bb-lock');
    }
    function showStep(name) {
      stepPick.classList.toggle('is-active', name === 'pick');
      stepReview.classList.toggle('is-active', name === 'review');
      if (name === 'review') renderReview();
    }

    /* ---- actions ---- */
    function pick(id) {
      var i = firstEmpty();
      if (i === -1) return;
      picked[i] = id;
      save(); renderAll();
      if (complete()) setTimeout(function () { showStep('review'); }, 280);
    }
    function removeAt(i) {
      if (i < 0 || i >= TOTAL) return;
      picked[i] = null;
      save(); renderAll();
    }

    /* ---- events ---- */
    mainSlots.forEach(function (slot, i) {
      slot.addEventListener('click', function (e) {
        if (e.target.closest('.bb-slot-remove')) { e.stopPropagation(); removeAt(i); return; }
        openModal(complete() ? 'review' : 'pick');
      });
    });

      $(".pick-button").click(function(){
        $(".bb-modal").addClass("is-open");
      })
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.bb-card');
      if (!card) return;
      var id = card.dataset.id;
      if (e.target.closest('.bb-card-zoom')) { e.stopPropagation(); openZoom(byId[id]); return; }
      if (e.target.closest('.bb-step-minus')) { e.stopPropagation(); var idx = lastIndexOf(id); if (idx !== -1) removeAt(idx); return; }
      if (e.target.closest('.bb-step-plus') || e.target.closest('.bb-card-add')) { e.stopPropagation(); pick(id); return; }
      if (e.target.closest('.bb-card-image')) pick(id);
    });

    tilesWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.bb-tile-swap');
      if (!btn) return;
      var tile = btn.closest('.bb-tile');
      removeAt(parseInt(tile.dataset.index, 10));
      showStep('pick');
    });

    modal.querySelectorAll('.bb-modal-close').forEach(function (b) { b.addEventListener('click', closeModal); });
    var goback = modal.querySelector('.bb-goback');
    if (goback) goback.addEventListener('click', closeModal);
    modal.querySelector('.bb-backdrop').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    /* ---- zoom ---- */
    function openZoom(p) {
      if (!p) return;
      var z = document.createElement('div');
      z.className = 'bb-zoom';
      z.innerHTML = '<button type="button" class="bb-zoom-close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 4L16 16M4 16L16 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>'
        + '<img src="' + (p.images[0] || p.image) + '" alt="">'
        + '<div class="bb-zoom-title">' + p.title + '</div>';
      document.body.appendChild(z);
      requestAnimationFrame(function () { z.classList.add('is-open'); });
      function close() { z.classList.remove('is-open'); setTimeout(function () { z.remove(); }, 220); }
      z.addEventListener('click', function (e) { if (e.target === z || e.target.closest('.bb-zoom-close')) close(); });
    }

    /* ---- sold today counter ---- */
    (function () {
      var el = root.querySelector('.bb-sold-count');
      if (!el) return;
      var base = parseInt(root.dataset.soldBase, 10) || 450;
      var INTERVAL = 3 * 60 * 1000;
      function update() {
        var now = new Date();
        var ms = now - new Date(now.getFullYear(), now.getMonth(), now.getDate());
        el.textContent = base + Math.floor(ms / INTERVAL);
      }
      update();
      setInterval(update, 60 * 1000);
    })();

    /* ---- restock date ---- */
    (function () {
      var el = root.querySelector('.bb-restock-label');
      if (!el) return;
      var days = parseInt(root.dataset.shipDays, 10) || 35;
      var d = new Date(); d.setDate(d.getDate() + days);
      var formatted;
      try { formatted = new Intl.DateTimeFormat(undefined, { month: 'long', day: 'numeric' }).format(d); }
      catch (e) { formatted = (d.getMonth() + 1) + '/' + d.getDate(); }
      el.textContent = 'Ships ' + formatted + ' (at full price)';
    })();

    /* ---- checkout ---- */
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (checkoutBtn.classList.contains('loading')) return;
        var ids = picked.filter(Boolean);
        if (ids.length === 0) return;
        checkoutBtn.classList.add('loading');

        var qty = {};
        ids.forEach(function (id) { qty[id] = (qty[id] || 0) + 1; });
        var items = Object.keys(qty).map(function (id) {
          return { id: Number(id), quantity: qty[id], properties: { _bundle: '2plus2' } };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || r.status); }); return r.json(); })
          .then(function () {
            clearSaved();
            window.location.href = root.dataset.redirect === 'cart' ? '/cart' : '/checkout';
          })
          .catch(function (err) {
            checkoutBtn.classList.remove('loading');
            alert('Could not add to cart: ' + (err && err.message ? err.message : 'unknown error') + '\nPlease try again.');
          });
      });
    }

    /* back from checkout via bfcache */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      checkoutBtn && checkoutBtn.classList.remove('loading');
      picked = load() || new Array(TOTAL).fill(null);
      renderAll();
      if (modal.classList.contains('is-open')) closeModal();
    });

    renderAll();
  }

  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-bb-root]'), initRoot); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  if (!window.__bbBound) {
    window.__bbBound = true;
    document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 0); });
    document.addEventListener('shopify:block:select', function () { setTimeout(initAll, 0); });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["how-to-block"] && !Shopify.designMode) return;
  try {
    (function () {
  function applyExtraStyle(root) {
    var extra = root.getAttribute('data-extra-style');
    if (extra) { root.style.cssText += ';' + extra; }
  }

  function initRoot(root) {
    if (root.dataset.htuReady === '1') return;
    root.dataset.htuReady = '1';
    applyExtraStyle(root);

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.htu-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.htu-panel'));
    if (panels.length === 0) return;

    function videoIn(panel) { return panel ? panel.querySelector('.htu-video') : null; }

    function playOnly(activePanel) {
      panels.forEach(function (p) {
        var v = videoIn(p);
        if (!v) return;
        if (p === activePanel) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }

    function activate(tabNum) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === String(tabNum);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var active = null;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === String(tabNum);
        p.classList.toggle('is-active', on);
        if (on) active = p;
      });
      playOnly(active);
    }

    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = tabs[(idx + dir + tabs.length) % tabs.length];
          if (next) { next.focus(); activate(next.getAttribute('data-tab')); }
        }
      });
    });

    // pause the active video when the block scrolls out of view
    var activePanelNow = function () { return root.querySelector('.htu-panel.is-active'); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = videoIn(activePanelNow());
          if (!v) return;
          if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      var v0 = videoIn(activePanelNow());
      if (v0) v0.play().catch(function () {});
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-htu-root]'), initRoot);
  }

  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }

  if (!window.__htuBound) {
    window.__htuBound = true;
    document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 0); });
    document.addEventListener('shopify:block:select', function () { setTimeout(initAll, 0); });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-showcase"] && !Shopify.designMode) return;
  try {
    (function () {
  function sourcesOf(slot) {
    return Array.prototype.map.call(slot.querySelectorAll('video source'), function (s) {
      return { src: s.src, type: s.getAttribute('type') || '' };
    });
  }

  function initRoot(root) {
    if (root.dataset.vsReady === '1') return;
    root.dataset.vsReady = '1';

    var autoplay = root.dataset.autoplay === 'true';
    var openSound = root.dataset.openSound === 'true';
    var slots = Array.prototype.slice.call(root.querySelectorAll('.vs-slot'));
    var filled = slots.filter(function (s) { return s.classList.contains('is-filled'); });
    var player = root.querySelector('.vs-player');
    if (!player) return;

    var main = player.querySelector('.vs-main-video');
    var rail = player.querySelector('.vs-rail');
    var cap = player.querySelector('.vs-stage-caption');
    var fill = player.querySelector('.vs-fill');
    var progress = player.querySelector('.vs-progress');
    var muteBtn = player.querySelector('.vs-mute');
    var center = player.querySelector('.vs-center');
    var closeBtn = player.querySelector('.vs-close');
    var shareBtn = player.querySelector('.vs-share');
    var current = 0;

    var ICON_VOL = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
    var ICON_MUTE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>';

    var previews = [];
    slots.forEach(function (s) { var v = s.querySelector('.vs-vid'); if (v) previews.push(v); });
    if (autoplay) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
          });
        }, { threshold: 0.2 });
        previews.forEach(function (v) { io.observe(v); });
      } else {
        previews.forEach(function (v) { v.play().catch(function () {}); });
      }
    }

    function showCenter() { center.classList.add('is-show'); }
    function hideCenter() { center.classList.remove('is-show'); }
    function refreshMute() {
      muteBtn.innerHTML = main.muted ? ICON_MUTE : ICON_VOL;
      muteBtn.setAttribute('aria-label', main.muted ? 'Unmute' : 'Mute');
    }

    function setSources(video, slot) {
      while (video.firstChild) video.removeChild(video.firstChild);
      sourcesOf(slot).forEach(function (sr) {
        var so = document.createElement('source');
        so.src = sr.src;
        if (sr.type) so.type = sr.type;
        video.appendChild(so);
      });
      var poster = slot.getAttribute('data-poster');
      if (poster) { video.poster = poster; } else { video.removeAttribute('poster'); }
    }

    function buildRail() {
      rail.innerHTML = '';
      filled.forEach(function (slot, idx) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'vs-thumb' + (idx === current ? ' is-active' : '');
        t.setAttribute('aria-label', 'Play ' + (slot.getAttribute('data-caption') || ''));
        var v = document.createElement('video');
        v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.preload = 'metadata';
        setSources(v, slot);
        v.play().catch(function () {});
        t.appendChild(v);
        t.addEventListener('click', function () { current = idx; load(idx); setActive(); });
        rail.appendChild(t);
      });
    }

    function setActive() {
      Array.prototype.forEach.call(rail.children, function (c, i) { c.classList.toggle('is-active', i === current); });
    }

    function load(i) {
      var slot = filled[i];
      current = i;
      cap.textContent = slot.getAttribute('data-caption') || '';
      setSources(main, slot);
      main.muted = openSound ? false : true;
      main.load();
      main.play().then(hideCenter).catch(showCenter);
      refreshMute();
    }

    function open(i) {
      current = i;
      buildRail();
      load(i);
      player.classList.add('is-open');
      requestAnimationFrame(function () { player.classList.add('is-visible'); });
      document.documentElement.classList.add('vs-lock');
      closeBtn.focus();
    }

    function close() {
      player.classList.remove('is-visible');
      main.pause();
      setTimeout(function () { player.classList.remove('is-open'); }, 260);
      document.documentElement.classList.remove('vs-lock');
    }

    filled.forEach(function (slot, idx) {
      var c = slot.querySelector('.vs-circle');
      if (!c) return;
      c.addEventListener('click', function () { open(idx); });
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(idx); }
      });
    });

    function togglePlay() {
      if (main.paused) { main.play().then(hideCenter).catch(function () {}); }
      else { main.pause(); showCenter(); }
    }

    main.addEventListener('click', togglePlay);
    center.addEventListener('click', togglePlay);
    main.addEventListener('play', hideCenter);
    main.addEventListener('pause', function () { if (main.currentTime < main.duration) showCenter(); });
    main.addEventListener('ended', showCenter);
    main.addEventListener('timeupdate', function () {
      if (main.duration) fill.style.width = (main.currentTime / main.duration * 100) + '%';
    });
    progress.addEventListener('click', function (e) {
      var r = progress.getBoundingClientRect();
      var ratio = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      if (main.duration) main.currentTime = ratio * main.duration;
    });

    muteBtn.addEventListener('click', function () { main.muted = !main.muted; refreshMute(); });
    closeBtn.addEventListener('click', close);
    shareBtn.addEventListener('click', function () {
      var data = {
        title: document.title,
        text: (filled[current] && filled[current].getAttribute('data-caption')) || '',
        url: window.location.href
      };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(window.location.href); }
    });

    document.addEventListener('keydown', function (e) {
      if (!player.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); current = (current + 1) % filled.length; load(current); setActive(); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); current = (current - 1 + filled.length) % filled.length; load(current); setActive(); }
      else if (e.key === ' ') { e.preventDefault(); togglePlay(); }
      else if (e.key.toLowerCase() === 'm') { main.muted = !main.muted; refreshMute(); }
    });

    refreshMute();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vs-root]'), initRoot);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  if (!window.__vsShowcaseBound) {
    window.__vsShowcaseBound = true;
    document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 0); });
    document.addEventListener('shopify:block:select', function () { setTimeout(initAll, 0); });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
